import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { FilterOutlined, CheckOutlined } from '@ant-design/icons';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// ─── Styled components ────────────────────────────────────────────────────────
var StyledWrapper = styled.div.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledWrapper",
  componentId: "sc-j8pe0t-0"
})(["position:relative;display:inline-block;"]);
var StyledTrigger = styled.button.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledTrigger",
  componentId: "sc-j8pe0t-1"
})(["display:inline-flex;align-items:center;gap:8px;height:50px;padding:0 16px;border-radius:12px;border:1.5px solid ", ";background:", ";color:", ";font-size:14px;font-weight:500;cursor:pointer;transition:all 0.2s cubic-bezier(0.4,0,0.2,1);white-space:nowrap;user-select:none;box-shadow:0 1px 2px rgba(0,0,0,0.03);&:hover{border-color:", ";color:", ";background:", ";transform:translateY(-1px);box-shadow:0 4px 12px rgba(26,90,255,0.1);}&:active{transform:translateY(0);}", ""], styleVariables.colors.grey14, styleVariables.colors.gray1, styleVariables.colors.grey100, styleVariables.colors.blue3, styleVariables.colors.blue3, styleVariables.colors.blue1, function (_ref) {
  var $active = _ref.$active;
  return $active && "\n    border-color: ".concat(styleVariables.colors.blue3, ";\n    color: ").concat(styleVariables.colors.blue3, ";\n    background: ").concat(styleVariables.colors.blue1, ";\n    font-weight: 600;\n  ");
});
var StyledBadge = styled.span.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledBadge",
  componentId: "sc-j8pe0t-2"
})(["display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:", ";color:#ffffff;font-size:11px;font-weight:700;line-height:1;"], styleVariables.colors.blue3);
var StyledChevron = styled.span.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledChevron",
  componentId: "sc-j8pe0t-3"
})(["display:inline-flex;transition:transform 0.15s ease;transform:", ";opacity:0.6;"], function (_ref2) {
  var $open = _ref2.$open;
  return $open ? 'rotate(180deg)' : 'rotate(0deg)';
});
var StyledPanel = styled.div.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledPanel",
  componentId: "sc-j8pe0t-4"
})(["position:absolute;top:calc(100% + 8px);right:0;z-index:1000;min-width:260px;max-width:340px;background:", ";border:1px solid ", ";border-radius:16px;box-shadow:0 12px 32px rgba(0,0,0,0.12);padding:12px 8px;overflow:hidden;animation:slideIn 0.2s ease-out;@keyframes slideIn{from{opacity:0;transform:translateY(-8px);}to{opacity:1;transform:translateY(0);}}"], styleVariables.colors.gray1, styleVariables.colors.grey14);
var StyledSectionTitle = styled.div.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledSectionTitle",
  componentId: "sc-j8pe0t-5"
})(["padding:12px 16px 8px;font-size:13px;font-weight:700;color:", ";text-transform:uppercase;letter-spacing:0.8px;"], styleVariables.colors.grey70);
var StyledPanelItem = styled.button.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledPanelItem",
  componentId: "sc-j8pe0t-6"
})(["display:flex;align-items:center;gap:12px;width:calc(100% - 16px);padding:10px 12px;border:1px solid transparent;background:", ";color:", ";font-size:14px;font-weight:", ";cursor:pointer;text-align:left;transition:all 0.15s ease;border-radius:10px;margin:2px 8px;&:hover{background:", ";color:", ";}", ""], function (_ref3) {
  var $active = _ref3.$active;
  return $active ? styleVariables.colors.blue1 : 'transparent';
}, function (_ref4) {
  var $active = _ref4.$active;
  return $active ? styleVariables.colors.blue3 : styleVariables.colors.grey100;
}, function (_ref5) {
  var $active = _ref5.$active;
  return $active ? 600 : 400;
}, styleVariables.colors.gray2, styleVariables.colors.blue3, function (_ref6) {
  var $active = _ref6.$active;
  return $active && "\n    border-color: ".concat(styleVariables.colors.blue3, ";\n    &:hover {\n      background: ").concat(styleVariables.colors.blue1, ";\n    }\n  ");
});
var StyledCheck = styled.span.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledCheck",
  componentId: "sc-j8pe0t-7"
})(["margin-left:auto;opacity:", ";font-size:14px;color:inherit;display:flex;align-items:center;"], function (_ref7) {
  var $visible = _ref7.$visible;
  return $visible ? 1 : 0;
});
var StyledStatusDot = styled.span.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledStatusDot",
  componentId: "sc-j8pe0t-8"
})(["width:8px;height:8px;border-radius:50%;background-color:", ";flex-shrink:0;"], function (_ref8) {
  var $color = _ref8.$color;
  return $color || styleVariables.colors.gray10;
});
var StyledDivider = styled.hr.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledDivider",
  componentId: "sc-j8pe0t-9"
})(["margin:8px 0;border:none;border-top:1px solid ", ";"], styleVariables.colors.grey14);
var StyledClearBtn = styled.button.withConfig({
  displayName: "combined-filter-dropdowncomponent__StyledClearBtn",
  componentId: "sc-j8pe0t-10"
})(["display:flex;align-items:center;justify-content:center;width:100%;padding:12px 16px;border:none;background:transparent;color:", ";font-size:15px;font-weight:600;cursor:pointer;text-align:center;transition:all 0.2s;&:hover{color:", ";background:", ";}"], styleVariables.colors.grey70, styleVariables.colors.blue3, styleVariables.colors.gray2); // ─── Chevron SVG ─────────────────────────────────────────────────────────────

var ChevronIcon = function ChevronIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 4L6 8L10 4",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}; // ─── Status Color Map ───────────────────────────────────────────────────────


var STATUS_COLORS = {
  all: styleVariables.colors.grey70,
  '5': '#FF8A00',
  // Upcoming (Orange)
  '6': '#195AFF',
  // Ongoing (Blue)
  '7': '#FF8A00',
  // Grading (Orange)
  '8': '#52C41A',
  // Completed/Ended (Green)
  ACTIVE: '#52C41A',
  ARCHIVED: styleVariables.colors.grey70
}; // ─── Component ────────────────────────────────────────────────────────────────

export var CombinedFilterDropdown = function CombinedFilterDropdown(_ref9) {
  var typeOptions = _ref9.typeOptions,
      statusOptions = _ref9.statusOptions,
      selectedTypes = _ref9.selectedTypes,
      selectedStatuses = _ref9.selectedStatuses,
      onTypeChange = _ref9.onTypeChange,
      onStatusChange = _ref9.onStatusChange,
      onClearAll = _ref9.onClearAll,
      labels = _ref9.labels,
      _ref9$singleStatus = _ref9.singleStatus,
      singleStatus = _ref9$singleStatus === void 0 ? false : _ref9$singleStatus,
      _ref9$showAllStatuses = _ref9.showAllStatuses,
      showAllStatuses = _ref9$showAllStatuses === void 0 ? true : _ref9$showAllStatuses;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var wrapperRef = useRef(null); // Close on outside click

  var handleBlur = function handleBlur(e) {
    var _wrapperRef$current;

    if (!((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.contains(e.relatedTarget))) {
      setOpen(false);
    }
  };

  var isAllTypesSelected = selectedTypes.length === 0;
  var isAllStatusesSelected = selectedStatuses.length === 0;
  var totalSelected = selectedTypes.length + selectedStatuses.length;
  var isActive = totalSelected > 0;

  var toggleType = function toggleType(typeId) {
    if (selectedTypes.includes(typeId)) {
      onTypeChange([]);
    } else {
      onTypeChange([typeId]);
    }
  };

  var toggleStatus = function toggleStatus(statusId) {
    if (singleStatus) {
      onStatusChange([statusId]);
      setOpen(false);
      return;
    }

    if (selectedStatuses.includes(statusId)) {
      var next = selectedStatuses.filter(function (s) {
        return s !== statusId;
      });
      onStatusChange(next);
    } else {
      onStatusChange([].concat(_toConsumableArray(selectedStatuses), [statusId]));
    }
  };

  var handleSelectAllTypes = function handleSelectAllTypes() {
    onTypeChange([]);
  };

  var handleSelectAllStatuses = function handleSelectAllStatuses() {
    onStatusChange([]);
  };

  var handleClearAll = function handleClearAll() {
    if (onClearAll) {
      onClearAll();
    } else {
      onTypeChange([]);
      onStatusChange([]);
    }
  };

  return /*#__PURE__*/_jsxs(StyledWrapper, {
    ref: wrapperRef,
    onBlur: handleBlur,
    tabIndex: -1,
    children: [/*#__PURE__*/_jsxs(StyledTrigger, {
      type: "button",
      $active: isActive,
      onClick: function onClick() {
        return setOpen(function (v) {
          return !v;
        });
      },
      "aria-haspopup": "listbox",
      "aria-expanded": open,
      children: [/*#__PURE__*/_jsx(FilterOutlined, {}), "Filters", isActive && /*#__PURE__*/_jsx(StyledBadge, {
        children: totalSelected
      }), /*#__PURE__*/_jsx(StyledChevron, {
        $open: open,
        children: /*#__PURE__*/_jsx(ChevronIcon, {})
      })]
    }), open && /*#__PURE__*/_jsxs(StyledPanel, {
      role: "listbox",
      children: [typeOptions.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledSectionTitle, {
          children: labels.typeSection
        }), /*#__PURE__*/_jsxs(StyledPanelItem, {
          type: "button",
          $active: isAllTypesSelected,
          onClick: handleSelectAllTypes,
          role: "option",
          "aria-selected": isAllTypesSelected,
          children: [labels.allTypes, /*#__PURE__*/_jsx(StyledCheck, {
            $visible: isAllTypesSelected,
            children: /*#__PURE__*/_jsx(CheckOutlined, {})
          })]
        }), typeOptions.map(function (option) {
          var isChecked = selectedTypes.includes(option.id);
          return /*#__PURE__*/_jsxs(StyledPanelItem, {
            type: "button",
            $active: isChecked,
            onClick: function onClick() {
              return toggleType(option.id);
            },
            role: "option",
            "aria-selected": isChecked,
            children: [option.label, /*#__PURE__*/_jsx(StyledCheck, {
              $visible: isChecked,
              children: /*#__PURE__*/_jsx(CheckOutlined, {})
            })]
          }, option.id);
        }), /*#__PURE__*/_jsx(StyledDivider, {})]
      }), /*#__PURE__*/_jsx(StyledSectionTitle, {
        children: labels.statusSection
      }), showAllStatuses && /*#__PURE__*/_jsxs(StyledPanelItem, {
        type: "button",
        $active: isAllStatusesSelected,
        onClick: handleSelectAllStatuses,
        role: "option",
        "aria-selected": isAllStatusesSelected,
        children: [/*#__PURE__*/_jsx(StyledStatusDot, {
          $color: STATUS_COLORS.all
        }), labels.allStatuses, /*#__PURE__*/_jsx(StyledCheck, {
          $visible: isAllStatusesSelected,
          children: /*#__PURE__*/_jsx(CheckOutlined, {})
        })]
      }), statusOptions.map(function (option) {
        var isChecked = selectedStatuses.includes(option.id);
        return /*#__PURE__*/_jsxs(StyledPanelItem, {
          type: "button",
          $active: isChecked,
          onClick: function onClick() {
            return toggleStatus(option.id);
          },
          role: "option",
          "aria-selected": isChecked,
          children: [/*#__PURE__*/_jsx(StyledStatusDot, {
            $color: STATUS_COLORS[option.id]
          }), option.label, /*#__PURE__*/_jsx(StyledCheck, {
            $visible: isChecked,
            children: /*#__PURE__*/_jsx(CheckOutlined, {})
          })]
        }, option.id);
      }), isActive && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledDivider, {}), /*#__PURE__*/_jsx(StyledClearBtn, {
          type: "button",
          onClick: handleClearAll,
          children: "\u2715 Clear all filters"
        })]
      })]
    })]
  });
};